import { motion } from "framer-motion";

export function LeadershipIllustration() {
  return (
    <div className="pointer-events-none relative h-[180px] w-full max-w-[340px] opacity-90">
      <svg viewBox="0 0 340 180" className="h-full w-full">
        <defs>
          <linearGradient id="li-violet" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#8B5CF6" stopOpacity="0.55" /><stop offset="100%" stopColor="#e879f9" stopOpacity="0.25" />
          </linearGradient>
          <linearGradient id="li-cyan" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#22D3EE" stopOpacity="0.5" /><stop offset="100%" stopColor="#0EA5E9" stopOpacity="0.2" />
          </linearGradient>
          <radialGradient id="li-glow" cx="0.5" cy="0.5" r="0.5">
            <stop offset="0%" stopColor="#A78BFA" stopOpacity="0.6" /><stop offset="100%" stopColor="#A78BFA" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="80" cy="110" r="60" fill="url(#li-glow)" />
        <motion.path d="M80,120 C 130,120 160,70 230,55" stroke="url(#li-violet)" strokeWidth="2" fill="none" strokeDasharray="4 6"
          initial={{ pathLength:0 }} animate={{ pathLength:1 }} transition={{ duration:1.4, delay:0.4, ease:"easeOut" }} />
        <motion.path d="M80,120 C 140,120 180,130 250,135" stroke="url(#li-cyan)" strokeWidth="2" fill="none" strokeDasharray="4 6"
          initial={{ pathLength:0 }} animate={{ pathLength:1 }} transition={{ duration:1.4, delay:0.6, ease:"easeOut" }} />
        <motion.g initial={{ y:4, opacity:0 }} animate={{ y:[0,-4,0], opacity:1 }}
          transition={{ opacity:{ duration:0.6 }, y:{ duration:5, repeat:Infinity, ease:"easeInOut" } }}>
          <circle cx="80" cy="92" r="14" fill="url(#li-violet)" />
          <path d="M58,128 Q80,108 102,128 L102,140 L58,140 Z" fill="url(#li-violet)" opacity="0.85" />
        </motion.g>
        <motion.circle cx="230" cy="55" r="14" fill="url(#li-violet)"
          initial={{ scale:0 }} animate={{ scale:1 }} transition={{ type:"spring", stiffness:260, damping:14, delay:1.4 }} />
        <motion.circle cx="250" cy="135" r="14" fill="url(#li-cyan)"
          initial={{ scale:0 }} animate={{ scale:1 }} transition={{ type:"spring", stiffness:260, damping:14, delay:1.6 }} />
        <motion.rect x="200" y="100" width="10" height="10" rx="2" fill="#22D3EE" opacity="0.5"
          animate={{ y:[100,92,100] }} transition={{ duration:4, repeat:Infinity, ease:"easeInOut" }} />
        <motion.rect x="285" y="85" width="8" height="8" rx="2" fill="#e879f9" opacity="0.5"
          animate={{ y:[85,77,85] }} transition={{ duration:3.5, repeat:Infinity, ease:"easeInOut", delay:0.4 }} />
      </svg>
    </div>
  );
}
